module.exports = __webpack_public_path__ + "img/KSC07557.1293893c.jpg";